import { Button, Checkbox, DatePicker, Input } from 'antd'
import Axios from 'axios'
import moment from 'moment'
import React, { useReducer } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import LineChart from '../../component/lineChart'
const { RangePicker } = DatePicker

interface IProps extends RouteComponentProps {
    form?: any
}

interface ContextObject {
    pageIndexState: any
    pageIndexDispatch: any
}

export const PageIndexContext = React.createContext<ContextObject>({} as ContextObject)

const Graphic: React.FC<IProps> = props => {
    const [state, setState] = React.useState({
        date: [moment(), moment().add({ days: 1 })] as [moment.Moment, moment.Moment],
        platform: '',
        district: [],
        category: '',
        contains: '',
        loading: false,
        data: [] as any[],
    })

    function getDevicesData(pageIndex: number): any {
        Axios.get('/devices/data', {
            params: {
                start: state.date[0].toISOString(),
                end: state.date[1].toISOString(),
                platform: state.platform,
                district: state.district,
                contains: state.contains,
                pageIndex,
            },
        })
            .then(res => {
                setState(prev => ({ ...prev, data: res.data.val }))

                pageIndexDispatch({
                    totalPage: res.data.totalDevices,
                })
            })
            .catch(err => console.error(err))
            .finally(() => {
                setState(prev => ({ ...prev, loading: false }))
            })
    }

    function reducer(state: { pageIndex: number; totalPage: number }, action: { pageIndex?: any; totalPage?: any }) {
        if (action.pageIndex) {
            setState(prev => ({ ...prev, loading: true }))
            getDevicesData(action.pageIndex)
        }

        return {
            pageIndex: action.pageIndex,
            totalPage: action.totalPage,
        }
    }
    const [pageIndexState, pageIndexDispatch] = useReducer(reducer, { pageIndex: 1, totalPage: 0 })

    const onSubmit = () => {
        setState(prev => ({ ...prev, loading: true }))
        getDevicesData(1)
    }

    const handleReset = () => {
        setState(prev => ({
            ...prev,
            date: [moment(), moment().add({ days: 1 })],
            platform: '',
            district: [],
            category: '',
        }))
    }

    const onChange = (date: any, dateString: any) => {
        setState(prev => ({
            ...prev,
            date,
        }))
    }

    const onPlatformTick = (e: any) => {
        const value = e.target.value
        setState(prev => ({
            ...prev,
            platform: prev.platform !== value ? value : '',
        }))
    }

    const onCategoryTick = (e: any) => {
        const value = e.target.value
        setState(prev => ({
            ...prev,
            category: prev.category !== value ? value : '',
        }))
    }

    const onInputChange = (evt: any) => {
        const value = evt.target.value
        setState(prev => ({ ...prev, district: value.split(',') }))
    }

    return (
        <>
            <div>
                <table style={{ lineHeight: '40px' }}>
                    <tbody>
                        <tr>
                            <td align="right">Date Range: </td>
                            <td align="left">
                                <RangePicker onChange={onChange} value={state.date} />
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Platform: </td>
                            <td align="left">
                                {' '}
                                <Checkbox checked={state.platform === 'lora'} onChange={onPlatformTick} value="lora">
                                    Lora
                                </Checkbox>
                                <Checkbox
                                    checked={state.platform === 'onenet'}
                                    value="onenet"
                                    onChange={onPlatformTick}
                                >
                                    Onenet
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">District: </td>
                            <td align="left">
                                <Input
                                    placeholder="Select district"
                                    // mode="multiple"
                                    onChange={onInputChange}
                                    style={{ width: '100%' }}
                                    value={state.district}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Category: </td>
                            <td align="left">
                                {' '}
                                <Checkbox
                                    checked={state.category === 'temperature'}
                                    onChange={onCategoryTick}
                                    value="temperature"
                                >
                                    Temperature
                                </Checkbox>
                                <Checkbox checked={state.category === 'rssi'} value="rssi" onChange={onCategoryTick}>
                                    RSSI
                                </Checkbox>
                                <Checkbox checked={state.category === 'snr'} value="snr" onChange={onCategoryTick}>
                                    SNR
                                </Checkbox>
                                <Checkbox
                                    checked={state.category === 'voltage'}
                                    value="voltage"
                                    onChange={onCategoryTick}
                                >
                                    Voltage
                                </Checkbox>
                                <Checkbox checked={state.category === 'TDC'} value="TDC" onChange={onCategoryTick}>
                                    TDC
                                </Checkbox>
                                <Checkbox checked={state.category === 'STDC'} value="STDC" onChange={onCategoryTick}>
                                    STDC
                                </Checkbox>
                                <Checkbox checked={state.category === 'roll'} value="roll" onChange={onCategoryTick}>
                                    Roll
                                </Checkbox>
                                <Checkbox checked={state.category === 'pitch'} value="pitch" onChange={onCategoryTick}>
                                    Pitch
                                </Checkbox>
                                <Checkbox checked={state.category === 'alert'} value="alert" onChange={onCategoryTick}>
                                    Alert
                                </Checkbox>
                                <Checkbox checked={state.category === 'CSQ'} value="CSQ" onChange={onCategoryTick}>
                                    CSQ
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="left">Sensor ID Contains</td>
                            <td>
                                <Input
                                    style={{ maxWidth: 300 }}
                                    value={state.contains}
                                    onChange={e => {
                                        const contains = e.target.value
                                        setState(prev => ({
                                            ...prev,
                                            contains,
                                        }))
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td colSpan={2}>
                                <Button type="primary" htmlType="submit" onClick={onSubmit}>
                                    Search
                                </Button>
                                <Button style={{ marginLeft: 12 }} onClick={handleReset}>
                                    Clear
                                </Button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <PageIndexContext.Provider
                    value={{
                        pageIndexState,
                        pageIndexDispatch,
                    }}
                >
                    <LineChart data={state.data} category={state.category} loading={state.loading} />
                </PageIndexContext.Provider>
            </div>
        </>
    )
}

export default Graphic
